import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let city = useDataValue({
    context: 'new_address',
    path: 'city',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return { term: city }
  }, [city])
}
